<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <div style="min-height:70vh">
      <div class="tips">生命灵数测算的结果</div>
      <!-- <div class="res">23:00-00:59(子时)</div> -->

      <div class="title">
        <div class="title-line"></div>
        <span>{{ data.features }}</span>
      </div>
      <div class="text">
        <div v-html="data.content"></div>
        <!-- <p>名利推来竟若何，前番辛苦后奔波。命中难养男与女，骨肉扶持也不多。</p> -->
      </div>
      <div class="text">
        <div v-html="data.target"></div>
        <!-- <p>名利推来竟若何，前番辛苦后奔波。命中难养男与女，骨肉扶持也不多。</p> -->
      </div>
    </div>
    <!-- <div class="title">
      <div class="title-line"></div>
      <span>右</span>
    </div>
    <div class="text">
      <p>
        此命为人品性不刚不柔，心中无毒，自当自担，离祖之命，做事有始有终，池塘鸳鸯觅食，或聚或散，骨肉六亲不得力，如嗥如风，劳心费力多成败，初限运寒多驳杂，祖业破败，重新白手成家，至三十五六方能成家立业，四十开外，如船遇顺风，五十多岁安稳,末限滔滔事业兴，妻宫硬配，子息伴架送终，寿元七十五岁，卒于五月之中。
        此命为人品性不刚不柔，心中无毒，自当自担，离祖之命，做事有始有终，池塘鸳鸯觅食，或聚或散，骨肉六亲不得力，如嗥如风，劳心费力多成败，初限运寒多驳杂，祖业破败，重新白手成家，至三十五六方能成家立业，四十开外，如船遇顺风，五十多岁安稳,末限滔滔事业兴，妻宫硬配，子息伴架送终，寿元七十五岁，卒于五月之中。
        此命为人品性不刚不柔，心中无毒，自当自担，离祖之命，做事有始有终，池塘鸳鸯觅食，或聚或散，骨肉六亲不得力，如嗥如风，劳心费力多成败，初限运寒多驳杂，祖业破败，重新白手成家，至三十五六方能成家立业，四十开外，如船遇顺风，五十多岁安稳,末限滔滔事业兴，妻宫硬配，子息伴架送终，寿元七十五岁，卒于五月之中。
        此命为人品性不刚不柔，心中无毒，自当自担，离祖之命，做事有始有终，池塘鸳鸯觅食，或聚或散，骨肉六亲不得力，如嗥如风，劳心费力多成败，初限运寒多驳杂，祖业破败，重新白手成家，至三十五六方能成家立业，四十开外，如船遇顺风，五十多岁安稳,末限滔滔事业兴，妻宫硬配，子息伴架送终，寿元七十五岁，卒于五月之中。
        此命为人品性不刚不柔，心中无毒，自当自担，离祖之命，做事有始有终，池塘鸳鸯觅食，或聚或散，骨肉六亲不得力，如嗥如风，劳心费力多成败，初限运寒多驳杂，祖业破败，重新白手成家，至三十五六方能成家立业，四十开外，如船遇顺风，五十多岁安稳,末限滔滔事业兴，妻宫硬配，子息伴架送终，寿元七十五岁，卒于五月之中。
      </p>
    </div> -->

    <div class="bottom-btn">

                    <font></font>

      <!-- <div class="start-btn" @click="$router.back()">重来一次</div> -->
        <btn></btn>

    </div>
    <div style="height: 1rem"></div>
  </div>
  </div>
</template>

<script>
/**
@description:生命灵数结果
@createTime:2021-08-25
@create:wq
*/
// import { formatRichText } from "@/utils/tool";
import topTab from "@/components/topTab";

import font from "@/components/font";
import btn from "@/components/publicBtn";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      data: "",
       rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'生命灵数',
        path:'/smls'
      },{
        name:'生命灵数',
      }]
    };
  },
      components: { topTab ,font,btn},

  watch: {},
  mounted() {},
  created() {
    const data = localStorage.getItem("result");
    if (data) this.data = JSON.parse(data);
  },
  destroyed() {
    localStorage.removeItem("result");
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
}
.tips {
  margin: 0.62rem 0 0.32rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.res {
  font-size: 0.3rem;
  font-weight: bold;
  color: #f9647d;
  margin-bottom: 0.5rem;
  text-align: center;
}

.title {
  display: flex;
  align-items: center;
  margin-top: 0.38rem;
  font-weight: bold;
  font-size: 0.3rem;
  font-weight: 400;
  color: #333333;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  white-space: pre-wrap;
  p {
    text-indent: 2em;
  }
}
.bottom-btn {
  margin: 0 auto;
  margin-top: 0.5rem;
  // position: fixed;
  // bottom: 1.2rem;
  // left: 50%;
  // transform: translateX(-50%);
  .ps {
    font-size: 0.24rem;
    font-weight: 400;
    color: #f9647d;
    text-align: center;
    margin-bottom: 0.18rem;
  }
}
.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>
